import { environment } from "../util";
export async function DetectCaptivePortal(
    apiDomain:string,
    probeUrl= "ping",
    probeExpectedValue="Healthy Connection",
    ) {
    try {
        const response = await fetch(probeUrl);
        console.log("Probe connecion test response", response);
        const json = await response.json();
        if (json.name === probeExpectedValue) {
          console.log('No captive portal detected.');
          return {isCaptivate:false,message: "",error: undefined};
        } else {
          console.log('Captive portal might be in the middle. Response:', json.name);
          return {isCaptivate:true,message: `Captive portal might be in the middle. Response: ${json.name}`, error: undefined};
        }
      } catch (error) {
        console.error('Error checking for captive portal:', error);
        return {isCaptivate:false,message: 'Error checcking for captive portal.', error: undefined};
      }
}
